import { Role } from '../types/staff';

/**
 * Action catalog. Each action declares which roles may perform it.
 *
 * Centralising the matrix here means the UI gating and (later) the
 * Firestore rules can stay in sync from a single source of truth.
 */
export type Action =
  // Staff management
  | 'manageStaff'
  | 'inviteStaff'
  | 'changeStaffRole'
  | 'removeStaff'
  // Client management
  | 'viewClients'
  | 'addClient'
  | 'editClient'
  | 'deleteClient'
  | 'archiveClient'
  | 'viewArchived'
  // Case / payment management
  | 'addCase'
  | 'editCase'
  | 'editCaseAmount'
  | 'addPayment'
  | 'editPayment'
  | 'addNote'
  | 'uploadDocument'
  | 'deleteDocument';

const PERMISSIONS: Record<Action, Role[]> = {
  manageStaff: ['admin'],
  inviteStaff: ['admin'],
  changeStaffRole: ['admin'],
  removeStaff: ['admin'],

  viewClients: ['admin', 'manager', 'staff'],
  addClient: ['admin', 'manager', 'staff'],
  editClient: ['admin', 'manager', 'staff'],
  deleteClient: ['admin'],
  archiveClient: ['admin', 'manager'],
  viewArchived: ['admin', 'manager'],

  addCase: ['admin', 'manager', 'staff'],
  editCase: ['admin', 'manager', 'staff'],
  editCaseAmount: ['admin', 'manager'],
  addPayment: ['admin', 'manager', 'staff'],
  editPayment: ['admin', 'manager'],
  addNote: ['admin', 'manager', 'staff'],
  uploadDocument: ['admin', 'manager', 'staff'],
  deleteDocument: ['admin', 'manager'],
};

export const can = (role: Role | undefined | null, action: Action): boolean => {
  if (!role) return false;
  return PERMISSIONS[action].includes(role);
};

export const hasAnyRole = (role: Role | undefined | null, allowed: Role[]): boolean => {
  if (!role) return false;
  return allowed.includes(role);
};
